import { Route, Routes } from 'react-router-dom'

import { NichtGefunden } from './seiten/NichtGefunden'
import { Start } from './seiten/Start'

/**
 * Die Wegekarte der Anwendung.
 *
 * Zwei Wege reichen fuer IS-31 — der Punkt ist nicht die Auswahl, sondern dass
 * es sie gibt: erst mit einem zweiten Weg zeigt sich, ob ein direkt
 * aufgerufener Link (`/gibtsnicht`) im Browser ankommt, statt vom Server mit
 * einem JSON-404 beantwortet zu werden. Die Arbeitsflaechen haengt IS-34 hier
 * ein.
 */
export function App() {
  return (
    <Routes>
      <Route path="/" element={<Start />} />
      <Route path="*" element={<NichtGefunden />} />
    </Routes>
  )
}
